import $ from 'jquery';
import Component from '../models/Component';

export default class NavigationSticky extends Component {
    constructor(element, context) {
        super(element, context);

        $(() => {

            function updateActiveLink() {
                $('.navigation_link').removeClass('active');
                const hash = window.location.hash.substring(1);
                if (hash) {
                    const activeLink = $('a.navigation_link.' + hash);
                    if (activeLink.length) {
                        activeLink.addClass('active');
                    }
                }
            }

            updateActiveLink();
            $(window).on('hashchange', updateActiveLink);

            $(window).on('scroll', function() {
                const scrollPosition = $(window).scrollTop();
                let currentSection = '';

                const offset = 100; 

                $('section').each(function() {
                    const sectionTop = $(this).offset().top;
                    const sectionHeight = $(this).outerHeight(); 

                    if (scrollPosition >= sectionTop - (sectionHeight / 2 + offset) ) {
                        currentSection = $(this).attr('id');
                    }

                    /* CONDIZIONE ORIGINALE (per riferimento):
                    if (scrollPosition >= sectionTop - sectionHeight / 2) {
                         currentSection = $(this).attr('id');
                    }
                    */
                });


                const currentHash = window.location.hash.substring(1);
                if (currentSection && currentSection !== currentHash) {

                    history.replaceState(null, null, '#' + currentSection);
                    updateActiveLink();
                } else if (!currentSection && currentHash) {
                }
            });
        });
    }
}